const style = (element, rules) => Object.assign(element.style, rules);

const syncUrl = (paused) => {
  const url = new URL(window.location.href);
  if (paused) url.searchParams.set("hotreload", "false");
  else url.searchParams.delete("hotreload");
  const nextUrl = url.toString();
  if (nextUrl !== window.location.href) window.location.replace(nextUrl);
};

export function installWatchModeToggle() {
  if (process.env.NODE_ENV !== "development" || typeof window === "undefined") {
    return;
  }

  const storageKey = "dev-hmr-paused";
  const storedPaused = localStorage.getItem(storageKey) === "1";
  const queryPaused =
    new URL(window.location.href).searchParams.get("hotreload") === "false";

  if (storedPaused !== queryPaused) {
    syncUrl(storedPaused);
    return;
  }

  if (document.getElementById("dev-watch-toggle")) return;

  let paused = storedPaused;
  const toggle = document.createElement("div");
  const row = document.createElement("div");
  const label = document.createElement("span");
  const track = document.createElement("span");
  const knob = document.createElement("span");
  const status = document.createElement("span");

  toggle.id = "dev-watch-toggle";
  style(toggle, {
    position: "fixed",
    right: "16px",
    bottom: "16px",
    zIndex: "2147483647",
    cursor: "pointer",
    userSelect: "none",
    padding: "10px 14px",
    minWidth: "202px",
    fontSize: "12px",
    color: "#f8fafc",
    background: "#111827",
    border: "1px solid #334155",
    borderRadius: "14px",
    boxShadow: "0 8px 24px rgba(0,0,0,.35)",
    fontFamily: "Inter, system-ui, -apple-system, sans-serif",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    alignItems: "center",
    overflow: "hidden",
    pointerEvents: "auto",
    lineHeight: "1.2",
  });
  style(row, { display: "flex", gap: "8px", alignItems: "center" });
  style(label, {
    fontSize: "12px",
    fontWeight: "700",
    letterSpacing: "0.01em",
    display: "inline-block",
    whiteSpace: "nowrap",
    color: "#f8fafc",
  });
  style(track, {
    position: "relative",
    display: "inline-block",
    width: "48px",
    height: "26px",
    borderRadius: "999px",
    transition: "background 160ms ease",
    flexShrink: "0",
  });
  style(knob, {
    position: "absolute",
    top: "2px",
    left: "2px",
    width: "22px",
    height: "22px",
    borderRadius: "999px",
    background: "#ffffff",
    boxShadow: "0 1px 6px rgba(0,0,0,.3)",
    transition: "transform 160ms ease",
  });
  style(status, {
    display: "inline-block",
    marginTop: "2px",
    fontSize: "11px",
    padding: "3px 8px",
    borderRadius: "999px",
    fontWeight: "600",
    color: "#fff",
    whiteSpace: "nowrap",
    lineHeight: "1.2",
  });

  const render = () => {
    const enabled = !paused;
    label.textContent = `Auto-reload: ${enabled ? "ON" : "OFF"}`;
    status.textContent = enabled ? "Live reload on" : "Reload paused";
    status.style.background = enabled ? "#0f766e" : "#991b1b";
    track.style.background = enabled ? "#34d399" : "#f87171";
    knob.style.transform = enabled ? "translateX(22px)" : "translateX(2px)";
    toggle.setAttribute("aria-pressed", String(enabled));
    toggle.setAttribute(
      "aria-label",
      `Auto-reload ${enabled ? "enabled" : "disabled"}`,
    );
  };

  const setPaused = (next) => {
    paused = next;
    localStorage.setItem(storageKey, next ? "1" : "0");
    render();
    syncUrl(next);
  };

  track.appendChild(knob);
  row.appendChild(label);
  row.appendChild(track);
  toggle.appendChild(row);
  toggle.appendChild(status);
  toggle.setAttribute("role", "button");
  toggle.setAttribute("tabindex", "0");
  toggle.title = "Toggle automatic page reload while in dev mode";
  toggle.addEventListener("click", () => setPaused(!paused));
  toggle.addEventListener("keydown", (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      setPaused(!paused);
    }
  });

  render();
  document.body.appendChild(toggle);
}
